<div
  *ngIf="!iSMinScreenLess1600() || (iSMinScreenLess1600() && !isOpenEditor())"
  class="info-conteiner-flex"
>
  <div class="comments-container">
    <ng-container [ngSwitch]="+infoBlockContent">
      <ks-comments
        (comparePhoto)="onComparePhoto($event)"
        (longerTask)="longTask($event)"
        *ngSwitchCase="9"
        [commentsDataSource]="commentsDataSource"
        [id]="image.id"
        [user]="user"
      >
      </ks-comments>
      <ks-info *ngSwitchCase="10" [infoTemplate]="infoTemplate"> </ks-info>
      <p *ngSwitchDefault>No Content</p>
    </ng-container>
    <span (click)="close()" class="close-button comments-container__btn">
      <!-- <fa-icon [icon]="['fas', 'times']"></fa-icon> -->
      <app-icon
        [icon]="['fas', 'times']"
        [iconName]="['Character', 'close']"
        color="#6b6b6b"
        [size]="22"
      ></app-icon>
    </span>
  </div>
  <div
    *ngIf="isOpenComparePhoto"
    class="compare-photo compare-photo__info-block"
  >
    <img [src]="comparePhotoUrl.url" alt="" />
    <span class="label">
      <span class="label-label">
        {{
          "Фото " +
            (comparePhotoUrl.from == "comment"
              ? "комментария"
              : "ответ мерчандайзера")
        }}
      </span>
    </span>
    <span (click)="closeComparePhoto()" class="close-button compare-photo__btn">
      <!-- <fa-icon [icon]="['fas', 'times']"></fa-icon> -->
      <app-icon
        [icon]="['fas', 'times']"
        [iconName]="['Character', 'close']"
        color="#6b6b6b"
        [size]="22"
      ></app-icon>
    </span>
  </div>
</div>
<div *ngIf="isOpenEditor()" class="editor-container">
  <ks-editor [imageUrl]="image.modal.extUrl" />
</div>
